<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Elective Merit List </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Academic Year"
                        outlined
                        @change="getStd();"
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        item-value="std_id"
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        persistent-hint
                        hint="Please Select Standard"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="stream_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="stream"
                        :items="stream_list"
                        item-text="str"
                        item-value="str_id"
                        label="Stream"
                        outlined
                        persistent-hint
                        hint="Please Select Stream"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="category_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="category"
                        item-value="id"
                        :items="category_list"
                        item-text="name"
                        label="Category"
                        outlined
                        persistent-hint
                        hint="Please Select Category"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" class="pt-8 pl-2" v-if="stream && sel_std_data && sel_ay_data">
                    <v-btn color="primary" @click="fetchElectiveMeritList()"> Fetch </v-btn>
                </v-col>
            </v-row>
            <v-row v-if="merit_list!=''" justify="center" dense>
                <v-btn color="primary" @click="generateElectiveMeritList()"> Generate </v-btn> </v-row
            ><v-row v-if="merit_list!=''" justify="center" dense>
                <center>
                    <strong>Note: After clicking on Generate, the previous merit list will be cleared.</strong>
                </center>
            </v-row>
            <v-btn color="success" class="ml-2" @click="exportExcel" v-if="merit_list.length" small>
                Export Excel
            </v-btn>
            <v-btn color="error" class="ml-2" @click="exportPdf" v-if="merit_list.length" small>
                Export PDF
            </v-btn>
            <v-data-table
                v-if="merit_list!=''"
                :headers="headers"
                @current-items="getFiltered"
                :items-per-page="-1"
                :items="bookList1"
                dense
                sort-by=""
                class="elevation-1 mytable"
                :search="search"
            >
                <template v-slot:top class="pb-5">
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete
                                                    class="mr-2 pb-5 pt-2"
                                                    flat
                                                    hide-details
                                                    small
                                                    rounded
                                                    dense
                                                    outlined
                                                    color="#0F2027"
                                                    :label="header.text"
                                                    multiple
                                                    clearable
                                                    :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"
                                                ></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
                <template v-slot:item.learner_choice="{ item }">
                    <!-- <v-row dense justify="center" v-for="p,index in item.learner_choice" key="index">
                        <strong>{{ p.pno }}</strong> {{ p.course }} -->
                        <v-simple-table  dense class="elevation-1">
                        <thead>
                        <tr>
                            <th>Pre. No.</th>
                            <th>Subject / Group</th>
                        </tr>
                        </thead>
                    <tbody>
                        <tr v-for="(p, index) in item.learner_choice" :key="index">
                            <td>{{ p.pno }}</td>
                            <td>{{ p.course }}</td>
                        </tr>
                    </tbody>
                        </v-simple-table>
                    <!-- </v-row> -->
                </template>
                
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import { stream } from "xlsx";
    import * as XLSX from "xlsx";
    export default {
        components: {
            Breadcrumbs,
        },

        data() {
            return {
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                overlay: false,
                stream: null,
                category: null,
                merit_list: [],
                filterArr: [],
                category_list:[],
                filters: {
                    registration_number: [],
                    name_of_candidate: [],
                    category: [],
                },
                headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Rank", value: "rank" },
                    { text: "Registration Number", value: "registration_number" },
                    { text: "Student Name", value: "name_of_candidate" },
                    { text: "Quota", value: "quota" },
                    { text: "Marks", value: "merit_marks" },
                    { text: "Percentage", value: "percentage" },
                    { text: "Email", value: "email" },
                    { text: "Mobile Number", value: "mobile_number" },
                    { text: "Category", value: "category" },
                    { text: "Academic Year", value: "ay" },
                    { text: "Standard", value: "standard" },
                    { text: "Stream", value: "stream" },
                    { text: "No. of Preferences", value: "preference_count" },
                    { text: "Preferences", value: "learner_choice" },
                ],
            };
        },
        computed: {
            bookList1() {
                return this.merit_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },

        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.merit_list.map((d) => d[val]);
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async generateElectiveMeritList() {
                const data = {
                    merit_list: this.merit_list,
                };
                try {
                    const res = await axios.post("/Admission/generateElectiveMeritList", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Merit List Saved Successfully...");
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            async fetchElectiveMeritList() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    std: this.sel_std_data,
                    stream: this.stream,
                    category: this.category,
                };
                try {
                    const res = await axios.post("/Admission/fetchElectiveMeritList", data);
                    if (res.data.flag == "YES") {
                        this.merit_list = res.data.merit_list;
                        if(this.merit_list.length == 0){
                            this.showSnackbar("#b71c1c", "No Data Found....");
                        }
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        console.log(res.data);
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.sel_ay_data;
                        this.stream_list = res.data.stream_list;
                        this.category_list = res.data.category_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            exportExcel() {
                const exportData = [];

                this.merit_list.forEach((item) => {
                    exportData.push({
                    Rank: item.rank,
                    Registration_No: item.registration_number,
                    Student_Name: item.name_of_candidate,
                    Quota: item.quota,
                    Marks: item.merit_marks,
                    Percentage: item.percentage,
                    Email: item.email,
                    Mobile: item.mobile_number,
                    Category: item.category,
                    Academic_Year: item.ay,
                    Standard: item.standard,
                    Stream: item.stream,
                    Preference_Count: item.preference_count,
                    Preferences: item.learner_choice
                        .map((p) => `${p.pno} - ${p.course}`)
                        .join("\n"),
                    });
                });

                const worksheet = XLSX.utils.json_to_sheet(exportData);
                const workbook = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(
                    workbook,
                    worksheet,
                    "Elective Merit List"
                );

                XLSX.writeFile(
                    workbook,
                    "Elective_Merit_List.xlsx"
                );
            },

            exportPdf() {
                let html = `
                <html>
                <head>
                    <title>Elective Merit List</title>
                    <style>
                        body{
                            font-family: Arial, sans-serif;
                            padding:20px;
                        }
                        h2{
                            text-align:center;
                            margin-bottom:20px;
                        }
                        table{
                            width:100%;
                            border-collapse:collapse;
                            font-size:12px;
                        }
                        th, td{
                            border:1px solid #000;
                            padding:5px;
                            text-align:center;
                            vertical-align:top;
                        }
                        th{
                            background:#E57C23;
                            color:white;
                        }
                        .pref-table{
                            width:100%;
                            border-collapse:collapse;
                        }
                        .pref-table th,
                        .pref-table td{
                            border:1px solid #999;
                            padding:3px;
                            font-size:11px;
                        }
                    </style>
                </head>
                <body>
                    <h2>Elective Merit List</h2>

                    <table>
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Registration No</th>
                                <th>Student Name</th>
                                <th>Quota</th>
                                <th>Marks</th>
                                <th>Percentage</th>
                                <th>Email</th>
                                <th>Mobile Number</th>
                                <th>Category</th>
                                <th>Academic Year</th>
                                <th>Standard</th>
                                <th>Stream</th>
                                <th>No. Of Preferences</th>
                                <th>Preferences</th>
                            </tr>
                        </thead>
                        <tbody>
                `;

                this.merit_list.forEach(item => {

                    let preferenceHtml = `
                        <table class="pref-table">
                            <tr>
                                <th>Pref No</th>
                                <th>Subject / Group</th>
                            </tr>
                    `;

                    item.learner_choice.forEach(pref => {
                        preferenceHtml += `
                            <tr>
                                <td>${pref.pno}</td>
                                <td>${pref.course}</td>
                            </tr>
                        `;
                    });

                    preferenceHtml += `</table>`;

                    html += `
                        <tr>
                            <td>${item.rank || ""}</td>
                            <td>${item.registration_number || ""}</td>
                            <td>${item.name_of_candidate || ""}</td>
                            <td>${item.quota || ""}</td>
                            <td>${item.merit_marks || ""}</td>
                            <td>${item.percentage || ""}</td>
                            <td>${item.email || ""}</td>
                            <td>${item.mobile_number || ""}</td>
                            <td>${item.category || ""}</td>
                            <td>${item.ay || ""}</td>
                            <td>${item.standard || ""}</td>
                            <td>${item.stream || ""}</td>
                            <td>${item.preference_count || ""}</td>
                            <td>${preferenceHtml}</td>
                        </tr>
                    `;
                });

                html += `
                        </tbody>
                    </table>
                </body>
                </html>
                `;

                const printWindow = window.open("");

                printWindow.document.open();
                printWindow.document.write(html);
                printWindow.document.close();

                printWindow.onload = function () {
                    printWindow.print();
                };
            }
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    thead th {
  background: #2980b9 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #E57C23,
    #E57C23,
    #E57C23
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #E57C23,
    #E57C23,
    #E57C23
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color:var(--v-brand-base);/* #2980b9 !important;*/
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
body{
    font-family: Arial, sans-serif;
    padding:10px;
    margin:0;
}

table{
    width:100%;
    border-collapse:collapse;
    table-layout:fixed;
    border:1px solid #000;
}

th, td{
    border:1px solid #000 !important;
    /* padding:3px; */
    font-size:10px;
    word-wrap:break-word;
    overflow-wrap:break-word;
}

@page{
    size: landscape;
    margin: 5mm;
}
</style>
